<template>
    <BreadCrumb PageTitle="Salle de Composition" />
    <DetailsComposition />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import DetailsComposition from "@/components/Composition/DetailsComposition.vue";
  
    export default defineComponent({
      name: "DetailsCompositionPage",
      components: {
        BreadCrumb,
        DetailsComposition,
      },
    });
  </script>